// Externe Bibliotheken
import React, { Component, memo } from 'react';

// Interne Module
import * as storage from '@/_helper/storage';
import { checkTripEnds, checkTripStarts } from '@/_helper/checkTripStarts';
import { tripStartCountdown } from '@/_helper/bookingDetailsHelper';
import globalParams from '@/_config/globalParams';
import BuildInfo from '@/_helper/buildInfo';
import { AppContext } from '@/context//AppContext';

// Komponenten
import ContactLayer from '@/comp/contactLayer';

// Styles
import './header.scss';

class Header extends Component {
    #navigationList = [];
    #bookingState;

    static contextType = AppContext;

    constructor(props) {
        super(props);

        this.state = {
            show: true,
            logoutHover: false,
            menuOpen: false,
            loggedIn: this.props.login !== undefined ? this.props.login : true,
            bookingData: storage.get('bookingData') !== null ? storage.get('bookingData').data : null,
        };
        this.navRef = React.createRef();
    }

    componentDidMount() {
        if (storage.get('mode') !== null && storage.get('mode') === 'app') {
            this.setState({
                show: false,
            });
        }

        if (this.props.bookingState) {
            window.$bookingState = this.props.bookingState;
        } else if (
            window.$bookingState === '' &&
            this.state.bookingData !== undefined &&
            this.state.bookingData !== null
        ) {
            let data = this.state.bookingData;
            if (data.searchParams.retDate !== undefined && tripStartCountdown(data.searchParams.retDate) === false) {
                this.#bookingState = 'over';
            } else if (data.serviceInformation?.package) {
                this.#bookingState =
                    data.serviceInformation.package.state === 'MO' ? 'OK' : data.serviceInformation.package.state;
            } else {
                this.#bookingState = 'NO';
            }

            window.$bookingState = this.#bookingState;
        }

        // affiliate
        if (window.$affiliate) {
            this.#navigationList.push({
                label: 'Reise reklamieren',
                name: 'reise-reklamieren',
                icon: 'sync_problem',
                index: 0,
            });
        } else if (window.$bookingState) {
            if (window.$browserInfo.device !== 'mobile') {
                this.#navigationList.push({
                    label: 'Buchungsübersicht',
                    name: 'buchungsuebersicht',
                    icon: 'explore',
                    index: 0,
                });
            }
            if (window.$bookingState === 'over') {
                this.#navigationList.push({
                    label: 'Zahlungsstatus einsehen',
                    name: 'zahlungsstatus',
                    icon: 'euro',
                    index: 4,
                });
                if (this.context?.travelType !== 'cruise') {
                    this.#navigationList.push({
                        label: 'Reise reklamieren',
                        name: 'reise-reklamieren',
                        icon: 'sync_problem',
                        index: 6,
                    });
                }
            } else {
                this.#navigationList.push(
                    {
                        label: 'Buchung verwalten oder ändern',
                        name: 'buchung-verwalten',
                        icon: 'edit_note',
                        index: 1,
                    },
                    { label: 'Dokumente anzeigen', name: 'dokumente-anzeigen', icon: 'description', index: 2 },
                    { label: 'Zusatzleistungen buchen', name: 'zusatzleistung', icon: 'attractions', index: 3 },
                    { label: 'Zahlungsstatus einsehen', name: 'zahlungsstatus', icon: 'euro', index: 4 }
                );
                if (this.props.loggedIn && this.state.bookingData?.allowedInteractions?.cancellation) {
                    const { completeCancellation, partialCancellation } =
                        this.state.bookingData.allowedInteractions.cancellation;

                    // show cancellation tab if logged in and at least one of the cancellation options is available
                    if (completeCancellation || Object.values(partialCancellation).some((value) => value === true)) {
                        this.#navigationList.push({
                            label: 'Stornierungsoptionen',
                            name: 'stornierungsoptionen',
                            icon: 'free_cancellation',
                            index: 5,
                        });
                    }
                }
                if (this.context?.travelType !== 'cruise') {
                    this.#navigationList.push({
                        label: 'Reise reklamieren',
                        name: 'reise-reklamieren',
                        icon: 'sync_problem',
                        index: 6,
                    });
                }
            }
        }

        // show if not production
        if (
            process.env.VITE_ENV !== 'production' &&
            !window.location.host.includes('aurumtours.de') &&
            !window.$affiliate
        ) {
            this.setLogoutTimer();
        }
    }

    handleLogoutClicked = () => {
        window.location.href = '#/logout';
    };

    handleMyTripClicked = () => {
        window.location.href = '#/';
    };

    handleOutsideClick(ref) {
        document.addEventListener('mouseup', (event) => {
            if (ref.current && !ref.current.contains(event.target) && this.state.menuOpen) {
                this.setState({
                    menuOpen: false,
                });
            }
        });
    }

    setLogoutTimer() {
        if (storage.get('login_timestamp')) {
            const getLogoutTime = () => {
                let autoLogoutTime = globalParams.autoLogoutTime;
                let logoutTime = autoLogoutTime - (new Date().getTime() - storage.get('login_timestamp'));

                return Math.round(logoutTime / 1000) + 's';
            };

            this.setState({
                logoutTimer: getLogoutTime(),
            });
            setInterval(() => {
                this.setState({
                    logoutTimer: getLogoutTime(),
                });
            }, 1000);
        }
    }

    render() {
        const { show, loggedIn } = this.state;
        this.handleOutsideClick(this.navRef);

        return (
            <>
                {show && (
                    <>
                        <div className="header no-print">
                            <div className="outer-wrapper">
                                {window.$affiliate ? (
                                    (() => {
                                        switch (window.$affiliate) {
                                            case 'ch24':
                                                return (
                                                    <div className="logo-container">
                                                        <div className="affiliate-ch24--logo-ch24"></div>
                                                    </div>
                                                );
                                            default:
                                                return (
                                                    <a className="logo-container" href="/#/">
                                                        <div className="aurum-logo"></div>
                                                    </a>
                                                );
                                        }
                                    })()
                                ) : (
                                    <>
                                        <a className="logo-container" href="/#/">
                                            <div className="aurum-logo"></div>
                                        </a>
                                    </>
                                )}

                                {/* get build info */}
                                <BuildInfo />

                                <div className="header-items">
                                    {this.state.logoutTimer && <div className="logoutTime"></div>}
                                    <nav className="header-nav">
                                        {this.state.logoutTimer && (
                                            <div className="menu-item">{`Ausloggen in ${this.state.logoutTimer}`}</div>
                                        )}
                                        {!window.$affiliate && (
                                            <>
                                                {loggedIn && (
                                                    <div
                                                        className="menu-item my-trip"
                                                        onClick={() => this.handleMyTripClicked()}>
                                                        <i className="material-symbols-outlined">explore</i>
                                                        <span className="title">
                                                            {this.context?.constants.MY_TRIP ?? 'Meine Reise'}
                                                        </span>
                                                    </div>
                                                )}
                                            </>
                                        )}

                                        {!window.$affiliate && <ContactLayer loggedIn={this.state.loggedIn} />}

                                        {!window.$affiliate && (
                                            <>
                                                {loggedIn && (
                                                    <div
                                                        className="menu-item logout"
                                                        onClick={() => this.handleLogoutClicked()}>
                                                        <i className="material-symbols-outlined">logout</i>
                                                        <span className="title">Ausloggen</span>
                                                    </div>
                                                )}
                                            </>
                                        )}
                                    </nav>

                                    {!window.$affiliate && (
                                        <>
                                            {loggedIn && (
                                                <nav className="popup-nav">
                                                    <span
                                                        className={`menu-button material-symbols-outlined ${
                                                            !this.state.menuOpen ? 'active' : ''
                                                        }`}
                                                        onClick={() => this.setState({ menuOpen: true })}>
                                                        menu
                                                    </span>
                                                    <span
                                                        className={`menu-button material-symbols-outlined ${
                                                            this.state.menuOpen ? 'active' : ''
                                                        }`}
                                                        onClick={() => this.setState({ menuOpen: false })}>
                                                        close
                                                    </span>

                                                    <ul
                                                        className={this.state.menuOpen ? 'active' : ''}
                                                        ref={this.navRef}>
                                                        <li className="bold">
                                                            <a
                                                                rel="noopener noreferrer"
                                                                href={'/#'}
                                                                onClick={() => this.setState({ menuOpen: false })}>
                                                                <i className="material-symbols-outlined">explore</i>
                                                                {this.context?.constants.MY_TRIP ?? 'Meine Reise'}
                                                            </a>
                                                        </li>
                                                        {this.#navigationList &&
                                                            this.#navigationList.map((item, index) => {
                                                                return (
                                                                    <li key={'headerNavigationItem' + index}>
                                                                        <a
                                                                            rel="noopener noreferrer"
                                                                            href={'/#/' + item.name}
                                                                            onClick={() =>
                                                                                this.setState({ menuOpen: false })
                                                                            }>
                                                                            {item.label}
                                                                        </a>
                                                                    </li>
                                                                );
                                                            })}
                                                        <div className="mobile-only">
                                                            <li className="bold">
                                                                <a
                                                                    rel="noopener noreferrer"
                                                                    target="_blank"
                                                                    href={`${window.$website}/service/kontakt`}>
                                                                    <i className="material-symbols-outlined">help</i>
                                                                    Kontakt
                                                                </a>
                                                            </li>

                                                            {checkTripStarts() && !checkTripEnds() && (
                                                                <li>
                                                                    <a
                                                                        rel="noopener noreferrer"
                                                                        href="tel:+4989998299531">
                                                                        +49 (0) 89 99 82 99 531
                                                                    </a>
                                                                </li>
                                                            )}

                                                            <li>
                                                                <a
                                                                    rel="noopener noreferrer"
                                                                    target="_blank"
                                                                    href={`${window.$website}/service/kontakt`}>
                                                                    Kontaktformular
                                                                </a>
                                                            </li>
                                                            <hr />
                                                            <li
                                                                className="bold"
                                                                onClick={() => this.handleLogoutClicked()}>
                                                                <i className="material-symbols-outlined">logout</i>
                                                                Ausloggen
                                                            </li>
                                                        </div>
                                                    </ul>
                                                </nav>
                                            )}
                                        </>
                                    )}

                                    {!window.$affiliate && (
                                        <>{window.$browserInfo.device === 'mobile' && !loggedIn && <ContactLayer />}</>
                                    )}
                                </div>
                            </div>
                        </div>
                        {!window.$affiliate && <>{this.state.menuOpen && <div className="menu-overlay"></div>}</>}
                    </>
                )}
            </>
        );
    }
}

export default memo(Header);
